
























import {Component, Vue, Model, Prop} from 'vue-property-decorator';
import qiniuUpload from './qiniuupload';
import _ from 'lodash';

@Component
export default class simpleFileUpload extends Vue {
    // @Model('change', {type: Object})
    // readonly file !: {
    //     name: string;
    //     url: string;
    // };


    @Prop()
    param!: any;

    randomRef = "";

    fileList: any[] = [];

    created() {
        this.randomRef = this.randomEngString(10);
    }

    randomEngString(length: number) {
        let randomString_code_string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ12345678910';

        var max_num = randomString_code_string.length + 1;
        var key = '';
        for (var i = 0; i < length; i++) {
            key += randomString_code_string.charAt(Math.floor(Math.random() * max_num));
        }
        return key;
    }

    uploadFile(options: any) {

        return qiniuUpload(options).then((file) => {
            //内部上传结束直接上传

            this.$emit('completeUpload', {param: this.param, file: file});
            // @ts-ignore
            this.$refs[this.randomRef].clearFiles();


        });
    }

}
